<template>
  <div class="listmain ">
    <!--<h1 class="firTitle">协议简介</h1>-->
	  <span>
<h3>
	<div>
		<span class="firTitle">协议概述</span>
	</div>
</h3>
<p>
	<span class="ql-author-7802039 ql-size-9">协议分为两部分： header 以及 payload</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">示例：</span>
</p>
</span>

	  <highlight-code lang="javascript">
		  {
		  "header": {
		      "namespace": "Orion.Iot.Device.Control",
			  "name": "TurnOn",
			  "messageId": "83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion": 1
		  },
		  "payload": {
			  "accessToken": "access token",
			  "deviceId": "12345abcde",
			  "deviceType": "XXX",
			  "attribute": "powerstate",
			  "value": "on",
			  "extensions": {
				  "extension1": "",
				  "extension2": ""
			 	 }
		 	  }
		  }
	  </highlight-code>

		  <div>
			  <span class="firTitle">header参数协议</span>
		  </div>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  参数名
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  参数类型
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  参数说明
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  是否必传
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  namespace
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  消息命名空间,详见本页1.2
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  是
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  name
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  详见本页1.3
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  是
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  payLoadVersion
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  int
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  payload 的版本,目前版本为 1
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  是
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  messageId
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  String
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  用于跟踪请求,返回的协议体中所包含的messageId与请求的协议体中的messageId是同一个
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  是
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <div>
		  <span class="firTitle">header协议中的namespace列表</span>
	  </div>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  namespace
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  解释说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  Orion.Iot.Device.Discovery
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备发现
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  Orion.Iot.Device.Control
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备控制
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <div>
		  <span class="firTitle">header协议中name列表</span>
	  </div>
	  <span>设备发现类（与Orion.Iot.Device.Discovery对应）</span>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  name
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  解释说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  DiscoveryDevices
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设备发现（获取设备列表）
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <br>
	  <span>操作类（与Orion.Iot.Device.Control对应）</span>
	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  name
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  解释说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  TurnOn
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  打开
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  TurnOff
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  关闭
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SelectChannel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  频道切换
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpChannel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  频道增加
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownChannel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  频道减少
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpVolume
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  声音按照步长调大
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownVolume
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  声音按照步长调小
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetVolume
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  声音调到某个值
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  Pause
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  暂停
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  Continue
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  继续
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetBrightness
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置亮度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpBrightness
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调大亮度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownBrightness
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调小亮度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetTemperature
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置温度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpTemperature
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调高温度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownTemperature
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调低温度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetWindSpeed
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置风速
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpWindSpeed
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调大风速
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownWindSpeed
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调小风速
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetMode
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  模式的切换
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetColor
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置颜色
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  CancelMode
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  取消模式(退出模式)
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetHumidity
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置湿度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpHumidity
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调大湿度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownHumidity
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调小湿度
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetWaterLevel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置水位
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpWaterLevel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调大水位
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownWaterLevel
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调小水位
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetSuction
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置吸力
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustUpSuction
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调大吸力
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  AdjustDownSuction
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  调小吸力
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  SetWindDirection
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  设置风向
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <span>
<h3>
		  <div>
			  <span class="firTitle">payload参数协议</span>
		  </div>
</h3>

<p>
	<span class="ql-author-7802039 ql-size-9">payload根据namespace不同分为Discovery、Control两类,详见设备发现、设备控制。</span>
</p>
</span>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
		display: inline-block;
		margin:20px 0;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/Zn_xygs.vue